import { Pipe, PipeTransform } from '@angular/core';
import { MapAddressAutocompleteItem } from './map-address/map-address.service';

export type HighlightPart = { titlePart: string; isHighlight: boolean };

@Pipe({
  name: 'pxwMapAutocompleteHightlights',
  standalone: true,
})
export class MapAutocompleteHightlightsPipe implements PipeTransform {
  transform(title: string, highlights: MapAddressAutocompleteItem['highlights']): HighlightPart[] {
    const titleParts: HighlightPart[] = [];

    let currentIndex = 0;

    for (let i = 0; i < highlights.length; i++) {
      const highlight = highlights[i];

      // Adds title part before highlight
      if (highlight.start > currentIndex) {
        titleParts.push({
          titlePart: title.substring(currentIndex, highlight.start),
          isHighlight: false,
        });
      }

      // Adds highlight
      titleParts.push({
        titlePart: title.substring(highlight.start, highlight.end),
        isHighlight: true,
      });

      // Updates current index
      currentIndex = highlight.end;
    }

    // Adds final part, if any
    if (currentIndex < title.length) {
      titleParts.push({
        titlePart: title.substring(currentIndex),
        isHighlight: false,
      });
    }

    return titleParts;
  }
}
